module.exports = __webpack_public_path__ + "img/mobexHealthHome2.fa8b5944.png";